import { Navigate, Route, Routes } from 'react-router-dom'
import { AgentEditor } from './AgentEditor'
import { AgentList } from './AgentList'
import { AgentSkillEditor } from './AgentSkillEditor'
import { AgentSkillList } from './AgentSkillList'

export default function AgentSettings() {
  return (
    <Routes>
      <Route index element={<AgentList />} />
      <Route path="skills" element={<AgentSkillList />} />
      <Route path="skills/:skillId" element={<AgentSkillEditor />} />
      <Route path=":agentId" element={<AgentEditor />} />
      <Route path="*" element={<Navigate to="/manage/agents" replace />} />
    </Routes>
  )
}
